import {setBaseTranslations} from './core/lang';
import baseOperationsStrings from './lang/base-operations.strings.yaml';
import baseTerminsStrings from './lang/base-termins.strings.yaml';
import baseStrings from './lang/base.strings.yaml';
// import currenciesNamesStrings from './lang/currencies-names.strings.yaml';
import currenciesSignStrings from './lang/currencies-sign.strings.yaml';
import greetingsStrings from './lang/greetings.strings.yaml';
import localeStrings from './lang/locale.strings.yaml';
import unitsStrings from './lang/units.strings.yaml';
import validationStrings from './lang/validation.strings.yaml';
import failreasonsStrings from './lang/failreasons.strings.yaml';

export default function initTranslations() {
    setBaseTranslations([
        baseOperationsStrings,
        baseTerminsStrings,
        baseStrings,
        // currenciesNamesStrings,
        currenciesSignStrings,
        greetingsStrings,
        localeStrings,
        unitsStrings,
        validationStrings,
        failreasonsStrings
    ]);
}
